export function ScoreMeter({ value = 0, label, sublabel, testid }) {
  const pct = Math.max(0, Math.min(100, value));
  const color = pct >= 70 ? "bg-accent" : pct >= 40 ? "bg-amber-400" : "bg-destructive/70";
  return (
    <div data-testid={testid} className="rounded-2xl border border-border bg-surface p-5 shadow-sm">
      <div className="flex items-baseline justify-between">
        <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">{label}</p>
        <p className="font-display text-2xl font-bold text-foreground tabular-nums">{pct}%</p>
      </div>
      <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-elevated">
        <div
          className={`h-full rounded-full transition-[width] duration-700 ${color}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      {sublabel && <p className="mt-3 text-xs text-muted-foreground">{sublabel}</p>}
    </div>
  );
}
